import { createStore, combineReducers, applyMiddleware } from 'redux'
import { chartSelected, theme,
         simDisplay, 
         colorArr, userWindow, 
        userPalette 
    } from './reducers'
import {stateData} from '../data/stateData'

const logger = store => next => action => {
    let result
    console.groupCollapsed("dispatching", action.type)
    console.log('prev state', store.getState())
    console.log('action', action)
    result = next(action)
    console.log('next state', store.getState())
    console.groupEnd()
    return result
}

const saver = store => next => action => {
    let result = next(action)
    localStorage['colorPikrReduxStore'] = JSON.stringify(store.getState())
    return result
}

const storeFactory = (initialState=stateData) =>
    applyMiddleware(logger, saver)(createStore)(
        combineReducers({chartSelected, theme, simDisplay, 
            colorArr, userWindow, 
            // vizData, 
            userPalette,
        }),
        // stateData
        (localStorage['colorPikrReduxStore']) ?
            JSON.parse(localStorage['colorPikrReduxStore']) :
            initialState
    )

export default storeFactory
